/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_PrevInputs */

const es_admin_billing_bills_list_prev = /** @type {(inputs: Admin_Billing_Bills_List_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const en_admin_billing_bills_list_prev = /** @type {(inputs: Admin_Billing_Bills_List_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Admin_Billing_Bills_List_PrevInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_prev = /** @type {((inputs?: Admin_Billing_Bills_List_PrevInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_PrevInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_prev(inputs)
	return en_admin_billing_bills_list_prev(inputs)
});
export { admin_billing_bills_list_prev as "admin.billing.bills_list.prev" }